import { useTranslation } from 'react-i18next'
import { CountDot, CountPill } from '@/shared/components/ui/count-pill'
import { NAV_SECTIONS, type NavItem, type NavItemCount, type NavSection } from './nav-config'

/** The items of a section that carry a counter. */
function countedItems(section: NavSection): NavItem[] {
  const items = section.items ?? section.groups?.flatMap((group) => group.items) ?? []
  return items.filter((item) => item.count !== undefined)
}

interface NavCountProps {
  count: NavItemCount
}

/** The item's counter as a pill next to its name. */
export function NavItemCountPill({ count }: NavCountProps) {
  const { t } = useTranslation()
  const value = count.useValue()
  return <CountPill count={value} label={t(count.ariaLabelKey, { count: value ?? 0 })} />
}

function NavCountDot({ count }: NavCountProps) {
  const { t } = useTranslation()
  const value = count.useValue()
  return <CountDot count={value} label={t(count.ariaLabelKey, { count: value ?? 0 })} />
}

interface NavSectionCountDotProps {
  section: NavSection
}

/** A dot on a section (Reporting) while one of its items has something waiting; the number lives on the item. */
export function NavSectionCountDot({ section }: NavSectionCountDotProps) {
  return (
    <>
      {countedItems(section).map((item) => item.count && <NavCountDot key={item.key} count={item.count} />)}
    </>
  )
}

/** The same dot on the menu button, so the counter is seen before the menu is opened. */
export function NavMenuCountDot() {
  return (
    <>
      {NAV_SECTIONS.map((section) => (
        <NavSectionCountDot key={section.key} section={section} />
      ))}
    </>
  )
}
